// removed by extract-text-webpack-plugin
module.exports = {"header":"_3MtG3LB-TbbDiQkfUnxA1j","dashboardControls":"_3uUSPiF0rujK8ZczhPdYON","item":"jmYuftWWpJD9MewDI9GiN","input":"_2yyCmNo56SoY2duIw7oPNd","userMoods":"_16UfjJ9LOskqkioVXqpvGX"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/UserDashboard.scss
// module id = 653
// module chunks = 0